// Carousel.tsx
// 'use client';

// import { useRef } from 'react';

interface CarouselProps {
  children: React.ReactNode;
  cardWidth?: string; // e.g., "w-72" or "w-80"
  gap?: string; // e.g., "gap-4" or "gap-6"
  gutterLeft?: string; // e.g., "w-4 sm:w-6" - width of left spacer
  gutterRight?: string; // e.g., "w-4 sm:w-6" - width of right spacer
}

// Helper function to convert width classes to padding-left classes
function getLeftPaddingClass(gutterClass: string): string {
  // Convert width classes like "w-4 sm:w-6" to padding-left classes
  return gutterClass
    .split(' ')
    .map((cls) => {
      if (cls.startsWith('w-')) {
        return cls.replace('w-', 'pl-');
      }
      if (cls.startsWith('sm:w-')) {
        return cls.replace('sm:w-', 'sm:pl-');
      }
      if (cls.startsWith('md:w-')) {
        return cls.replace('md:w-', 'md:pl-');
      }
      if (cls.startsWith('lg:w-')) {
        return cls.replace('lg:w-', 'lg:pl-');
      }
      if (cls.startsWith('xl:w-')) {
        return cls.replace('xl:w-', 'xl:pl-');
      }
      return cls;
    })
    .join(' ');
}

export default function Carousel({
  children,
  cardWidth = 'w-72',
  gap = 'gap-5',
  gutterLeft = '',
  gutterRight = '',
}: CarouselProps) {
  //   const carouselRef = useRef<HTMLDivElement>(null);

  //   const scroll = (direction: 'left' | 'right') => {
  //     if (carouselRef.current) {
  //       const scrollAmount = direction === 'left' ? -300 : 300;
  //       carouselRef.current.scrollBy({
  //         left: scrollAmount,
  //         behavior: 'smooth',
  //       });
  //     }
  //   };

  return (
    <div className="w-full h-full">
      {/* Carousel Wrapper */}
      <div className="relative group h-full">
        {/* Previous Button */}
        {/* <button
          onClick={() => scroll('left')}
          className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 z-10 bg-white rounded-full w-12 h-12 shadow-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-gray-50 active:scale-95"
          aria-label="Previous"
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button> */}

        {/* Carousel Container */}
        <div
          //   ref={carouselRef}
          className={`flex items-stretch h-full overflow-x-auto snap-x snap-mandatory scrollbar-hide scroll-smooth`}
        >
          {/* Render children with snap points and left padding */}
          {Array.isArray(children)
            ? children.map((child, index) => (
                <div
                  key={index}
                  className={`snap-start flex-shrink-0 flex ${
                    gutterLeft ? getLeftPaddingClass(gutterLeft) : ''
                  } ${index === 0 ? '' : gap.replace('gap-', 'ml-')}`}
                >
                  <div className={`flex ${cardWidth}`}>{child}</div>
                </div>
              ))
            : null}

          {/* Right spacer */}
          {gutterRight && <div className={`flex-shrink-0 ${gutterRight}`} />}
        </div>

        {/* Next Button */}
        {/* <button
          onClick={() => scroll('right')}
          className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 z-10 bg-white rounded-full w-12 h-12 shadow-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-gray-50 active:scale-95"
          aria-label="Next"
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </button> */}
      </div>
    </div>
  );
}
